<ng-container>
  <div class="search-filters-mobile">
    <div class="header">
      <div class="d-flex justify-content-between">
        <div class="back-link">
          <button
            class="btn btn-link p-0"
            (click)="backClicked()"
            data-track-elem="button"
            [attr.data-track-name]="'Back to ' + resultsString$()"
            [attr.aria-label]="'Back to ' + resultsString$()"
            >
            <i class="me-1 allycon-glyph-chevron-left" aria-hidden="true"></i>
            <span>{{ textResults$() }}@if(count$() > 1){s}</span>
          </button>
        </div>
    </div>
  </div>
  <div class="body">
    <app-search-filter [isMobile]="true"></app-search-filter>
    @if (showDateRange()) {
      <app-date-range
        dpElNamespace="mobile"
        class="ms-auto pt-2 mobile-datepicker"
      ></app-date-range>
    }
  </div>
</div>
</ng-container>
